window.handleGoogleAuthentication = response => {
  const form = document.getElementById('google-form')

  const idTokenInput = document.getElementById('google-credential')
  const stateInput = document.getElementById('google-state')

  idTokenInput.value = response.credential
  stateInput.value = response.state

  form.submit()
}
